import React, { FC } from 'react';
import * as Styled from './OInlineMessage.styles';
import { OInlineMessageProps, OInlineMessageStatus } from './OInlineMessage.types';
import { AIcon, AIconSize } from '../../atoms/AIcon';
import { ABody, ABodySize, ABodyColor } from '../../atoms/ABody';
import { MButton, MButtonType, MButtonSize, MButtonIconPlacement } from '../../molecules/MButton';
import { MParagraph, MParagraphAlignment } from '../../molecules/MParagraph';

const COMPONENT_NAME = 'o-mi-web-ui-kit-OInlineMessage';
const TEST_ID = 'mi-web-ui-kit-OInlineMessage';

const STATUS_ICON_MAP: Record<OInlineMessageStatus, string> = {
  Information: 'icon-information',
  Success: 'icon-success',
  Warning: 'icon-warning',
  ErrorSev1: 'icon-warning',
  ErrorSev2: 'icon-warning',
  Emergency: 'icon-warning',
};

const STATUS_ROLE_MAP: Record<OInlineMessageStatus, string> = {
  Information: 'status',
  Success: 'status',
  Warning: 'status',
  ErrorSev1: 'alert',
  ErrorSev2: 'alert',
  Emergency: 'alert',
};

const STATUS_ARIA_LIVE_MAP: Record<OInlineMessageStatus, 'polite' | 'assertive'> = {
  Information: 'polite',
  Success: 'polite',
  Warning: 'polite',
  ErrorSev1: 'assertive',
  ErrorSev2: 'assertive',
  Emergency: 'assertive',
};

export const OInlineMessage: FC<OInlineMessageProps> = ({ status, aBody, mParagraph, mButton, className }) => {
  const iconColor = Styled.getIconColor(status);

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      $status={status}
      role={STATUS_ROLE_MAP[status]}
      aria-live={STATUS_ARIA_LIVE_MAP[status]}
      className={className}
    >
      <Styled.IconWrapper>
        <AIcon icon={STATUS_ICON_MAP[status]} size={AIconSize.S} style={{ color: iconColor }} />
      </Styled.IconWrapper>
      <Styled.ContentWrapper>
        {aBody?.bodyText && <ABody size={ABodySize.S} color={ABodyColor.Default} bodyText={aBody.bodyText} />}
        {mParagraph?.aBody?.bodyText && (
          <MParagraph
            alignment={mParagraph.alignment === 'Centered' ? MParagraphAlignment.Center : MParagraphAlignment.Left}
            truncated={true}
            bodySize={ABodySize.S}
            bodyColor={ABodyColor.Default}
          >
            {mParagraph.aBody.bodyText}
          </MParagraph>
        )}
        {mButton?.buttonText && (
          <MButton
            buttonType={MButtonType.Tertiary}
            size={mButton.size ?? MButtonSize.L}
            iconPlacement={mButton.iconPlacement ?? MButtonIconPlacement.Trailing}
            ctaLink={mButton.ctaLink}
            openInANewTab={mButton.openInANewTab === 'true'}
          >
            {mButton.buttonText}
          </MButton>
        )}
      </Styled.ContentWrapper>
    </Styled.Wrapper>
  );
};

export { TEST_ID as O_INLINE_MESSAGE_TEST_ID };
export type { OInlineMessageProps };
